import { render } from "./keyborad.vue?vue&type=template&id=61a654b6&scoped=true&ts=true"
import script from "./keyborad.vue?vue&type=script&lang=ts"
export * from "./keyborad.vue?vue&type=script&lang=ts"

import "./keyborad.vue?vue&type=style&index=0&id=61a654b6&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a654b6"]])

export default __exports__